import * as RequestStatus from 'pricing-pages-ui/actions/constants/RequestStatus';
const requestsSelector = ({
  requests
}) => requests;
export const makeRequestStatusSelector = requestType => state => {
  const requestStatuses = requestsSelector(state);
  return requestStatuses[requestType] || RequestStatus.UNINITIALIZED;
};